<template>
    <div class="view view-practice-phonetic-transcription">
        <HeaderPractice
            headerText="Fonetik Transkripsiyon" />
        <ProgressbarPractice
            :indicatorPercent="indicatorPercent" />
        <div class="question-object-wrapper">
            <QuestionObjectPhoneticTranscription
                :value="curQuestion.transcriptionPhonemic" />
            <BtnVocalize />
        </div>
        
        <p
            class="description"
            :class="{'description--feedback': feedbackPhase}">Fonetik transkripsiyonunu yap.</p>
            
        <PhoneticInputs v-if="!feedbackPhase" />
        <OptionboardPhoneticTranscription v-if="!feedbackPhase" />

        <div
            class="feedbackboard-wrapper"
            v-if="feedbackPhase">
            <ScoreboardPhoneticTranscription
                :scorelist="scorelist" />
            <FeedbackboardPhoneticTranscription />
        </div>

        <BtnAnswerCheck
            v-if="!feedbackPhase"
            @click="$store.state.envDev ? checkAnswer() : checkAnswerApi()" />

        <BtnAnswerSkip
            v-if="!feedbackPhase"
            @click="$store.state.envDev ? skipAnswer() : skipAnswerApi()" />

        <BtnQuestionNext
            v-if="feedbackPhase"
            :correctness="correctness"
            @click="$store.state.envDev ? nextQuestion() : nextQuestionApi()" />

        <Feedbackbar
            v-if="feedbackPhase"
            :correctness="correctness" />

        <PreloaderPractice
            v-if="show.preloader" />
    </div>
</template>
<script>
    // Component imports.
    import HeaderPractice from '@/components/HeaderPractice.vue';
    import ProgressbarPractice from '@/components/ProgressbarPractice.vue';
    import QuestionObjectPhoneticTranscription from '@/components/QuestionObjectPhoneticTranscription.vue';
    import BtnVocalize from '@/components/BtnVocalize.vue';
    import PhoneticInputs from '@/components/PhoneticInputs.vue';
    import OptionboardPhoneticTranscription from '@/components/OptionboardPhoneticTranscription.vue';
    import FeedbackboardPhoneticTranscription from '@/components/FeedbackboardPhoneticTranscription';
    import ScoreboardPhoneticTranscription from '@/components/ScoreboardPhoneticTranscription.vue';
    import BtnAnswerCheck from '@/components/BtnAnswerCheck.vue';
    import BtnAnswerSkip from '@/components/BtnAnswerSkip.vue';
    import BtnQuestionNext from '@/components/BtnQuestionNext.vue';
    import Feedbackbar from '@/components/Feedbackbar.vue';
    import PreloaderPractice from '@/components/PreloaderPractice.vue';

    // Library imports.
    import FakeApi from '@/libs/FakeApi.js';

    export default {
        components: {
            HeaderPractice,
            ProgressbarPractice,
            QuestionObjectPhoneticTranscription,
            BtnVocalize,
            PhoneticInputs,
            OptionboardPhoneticTranscription,
            ScoreboardPhoneticTranscription,
            FeedbackboardPhoneticTranscription,
            BtnAnswerCheck,
            BtnAnswerSkip,
            BtnQuestionNext,
            Feedbackbar,
            PreloaderPractice,
        },

        data(){
            return {
                show: {
                    preloader: false,
                },
                allow: {
                    request: true,
                },
                numAnswered: 0,
                feedbackPhase: false,
                scorelist: [],
                correctness: 0,
            };
        },

        computed: {
            curQuestion(){
                let idxCurQuestion = this.$store.state.practiceSession.idxCurQuestion;
                return this.$store.state.questionSet[idxCurQuestion];
            },

            indicatorPercent(){
                let numQuestions = this.$store.state.questionSet.length;
                return (this.numAnswered / numQuestions) * 100;
            },
        },

        methods: {
            async checkAnswer(){
                // Check if all transcription inputs are filled.
                let answerTranscriptionSegmental = this.$store.state.answerData.transcriptionSegmental;
                for(let segment of answerTranscriptionSegmental){
                    if(segment == ''){
                        this.$foneturkError({
                            text: 'Transkripsiyonunda boş ses alanı olamaz.'
                        })
                        return;
                    }
                }

                // Check if request is allowed.
                if(!this.allow.request){
                    console.warn("VIEW_PRACTICE_PHONETIC_TRANSCRIPTION/CHECK_ANSWER::REQUEST_NOT_ALLOWED");
                    return;
                }
                this.allow.request = false;

                // Show preloader.
                this.show.preloader = true;
                await new Promise((resolve, reject) => {
                    setTimeout(() => {resolve();}, 2000);
                });

                // Predefine variables.
                let questionCorrectness = 1;
                let segmentCorrectness = 1;
                let scorelist = [];
                let feedbackData = {
                    transcriptionFull: {
                        correctValue: '',
                        answerValue: ''
                    },
                    transcriptionSegmental: {
                        correctValue: [],
                        answerValue: [],
                    }
                };

                // Compare full transcription.
                let correctTranscriptionFull = this.curQuestion.transcriptionFull;
                let answerTranscriptionFull  = answerTranscriptionSegmental.join("");
                feedbackData.transcriptionFull.correctValue = correctTranscriptionFull;
                feedbackData.transcriptionFull.answerValue  = answerTranscriptionFull;

                // Compare each segment.
                let correctTranscriptionSegmental = this.curQuestion.transcriptionSegmental;
                correctTranscriptionSegmental.forEach((correctSegment, idxCorrect) => {
                    segmentCorrectness = 1;
                    if(correctSegment != answerTranscriptionSegmental[idxCorrect]){
                        questionCorrectness = 0;
                        segmentCorrectness  = 0;
                    }
                    scorelist.push(segmentCorrectness);
                    feedbackData.transcriptionSegmental.correctValue[idxCorrect] = correctSegment;
                    feedbackData.transcriptionSegmental.answerValue[idxCorrect]  = answerTranscriptionSegmental[idxCorrect];
                });

                // Update dprops and vuex.
                this.numAnswered++;
                this.correctness = questionCorrectness;
                this.scorelist = scorelist;
                this.$store.commit('setFeedbackData', feedbackData);
                this.feedbackPhase = true;

                if(questionCorrectness == 1){
                    this.$store.commit('incrementPracticeStatCorrect');
                }
                else if(questionCorrectness == 0){
                    this.$store.commit('incrementPracticeStatIncorrect');
                }

                // Play SFX.
                if(questionCorrectness == 1){
                    this.$store.state.sfx.correct.currentTime = 0;
                    this.$store.state.sfx.correct.play();
                }
                else if(questionCorrectness == 0){
                    this.$store.state.sfx.incorrect.currentTime = 0;
                    this.$store.state.sfx.incorrect.play();
                }

                // Hide preloader.
                this.show.preloader = false;

                // Allow requests.
                this.allow.request = true;
            },

            checkAnswerApi(){
                // Check if all transcription inputs are filled.
                let answerTranscriptionSegmental = this.$store.state.answerData.transcriptionSegmental;
                for(let segment of answerTranscriptionSegmental){
                    if(segment == ''){
                        this.$foneturkError({
                            text: 'Transkripsiyonunda boş ses alanı olamaz.'
                        })
                        return;
                    }
                }

                // Check if request is allowed.
                if(!this.allow.request){
                    console.warn("VIEW_PRACTICE_PHONETIC_TRANSCRIPTION/CHECK_ANSWER_API::REQUEST_NOT_ALLOWED");
                    return;
                }
                this.allow.request = false;

                // Show preloader.
                this.show.preloader = true;

                // Send request.
                fetch(this.$store.state.api.checkAnswer, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    credentials: 'include',
                    body: "answerData=" + JSON.stringify(this.$store.state.answerData),
                })
                .then(async response => {
                    this.show.preloader = false;
                    if(response.status != 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(correctnessData => {
                    // Update dprops and vuex.
                    this.numAnswered++;
                    this.correctness = correctnessData.correctness;
                    this.scorelist   = correctnessData.scorelist;
                    this.$store.commit('setFeedbackData', correctnessData.feedbackData);
                    this.feedbackPhase = true;

                    // Play SFX.
                    if(this.correctness == 1){
                        this.$store.state.sfx.correct.currentTime = 0;
                        this.$store.state.sfx.correct.play();
                    }
                    else if(this.correctness == 0){
                        this.$store.state.sfx.incorrect.currentTime = 0;
                        this.$store.state.sfx.incorrect.play();
                    }

                    // Allow requests.
                    this.allow.request = true;
                })
                .catch(err => {
                    console.error(err);
                })
            },

            async skipAnswer(){
                // Check if request is allowed.
                if(!this.allow.request){
                    console.warn("VIEW_PRACTICE_PHONETIC_TRANSCRIPTION/SKIP_ANSWER::REQUEST_NOT_ALLOWED");
                    return;
                }
                this.allow.request = false;

                // Show preloader.
                this.show.preloader = true;
                await new Promise((resolve, reject) => {
                    setTimeout(() => {resolve();}, 2000);
                });

                // Predefine variables.
                let answerTranscriptionSegmental = [];
                let questionCorrectness = 1;
                let scorelist = [];
                let feedbackData = {
                    transcriptionFull: {
                        correctValue: '',
                        answerValue: ''
                    },
                    transcriptionSegmental: {
                        correctValue: [],
                        answerValue: [],
                    }
                };

                // Skip question.
                this.numAnswered++;
                questionCorrectness = -1;
                this.curQuestion.transcriptionSegmental.forEach(segment => {
                    answerTranscriptionSegmental.push('');
                    scorelist.push(-1);
                });
                
                feedbackData.transcriptionFull.correctValue = this.curQuestion.transcriptionFull;
                feedbackData.transcriptionFull.answerValue = '';
                
                feedbackData.transcriptionSegmental.correctValue = this.curQuestion.transcriptionSegmental;
                feedbackData.transcriptionSegmental.answerValue  = answerTranscriptionSegmental;

                // Update dprops and vuex.
                this.correctness = questionCorrectness;
                this.scorelist = scorelist;
                this.$store.commit('setFeedbackData', feedbackData);
                this.$store.commit('incrementPracticeStatSkipped');
                this.feedbackPhase = true;

                // Play SFX.
                this.$store.state.sfx.skipped.currentTime = 0;
                this.$store.state.sfx.skipped.play();

                // Hide preloader.
                this.show.preloader = false;

                // Allow request.
                this.allow.request = true;
            },

            skipAnswerApi(){
                // Check if request is allowed.
                if(!this.allow.request){
                    console.warn("VIEW_PRACTICE_PHONETIC_TRANSCRIPTION/SKIP_ANSWER_API::REQUEST_NOT_ALLOWED");
                    return;
                }
                this.allow.request = false;

                // Show preloader.
                this.show.preloader = true;

                // Send request.
                fetch(this.$store.state.api.skipAnswer, {
                    method: 'POST',
                    credentials: 'include',
                })
                .then(async response => {
                    this.show.preloader = false;
                    this.allow.request = true;
                    if(response.status != 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(correctnessData => {
                    // Update dprops and vuex.
                    this.numAnswered++;
                    this.correctness = correctnessData.correctness;
                    this.scorelist   = correctnessData.scorelist;
                    this.$store.commit('setFeedbackData', correctnessData.feedbackData);
                    this.feedbackPhase = true;

                    // Play SFX.
                    this.$store.state.sfx.skipped.currentTime = 0;
                    this.$store.state.sfx.skipped.play();
                })
                .catch(err => {
                    console.error(err);
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                });

            },

            nextQuestion(){
                // Check if this was the last question; if so terminate the practice session.
                let numQuestions = this.$store.state.questionSet.length;
                let numCurQuestion = this.$store.state.practiceSession.idxCurQuestion + 1;

                if(numCurQuestion == numQuestions){
                    alert("Practice session has ended.");
                    this.$router.push('/practice-results');
                    return;
                }

                // Check if request is allowed.
                if(!this.allow.request){
                    console.warn("VIEW_PRACTICE_PHONETIC_TRANSCRIPTION/NEXT_QUESTION::REQUEST_NOT_ALLOWED");
                    return;
                }
                this.allow.request = false;

                // Reset dprops.
                this.correctness = null;
                this.scorelist   = [];

                // Reset answer schema.
                let nxtQuestion = this.$store.state.questionSet[this.$store.state.practiceSession.idxCurQuestion + 1];
                let transcriptionSegmentalSchema = [];
                nxtQuestion.transcriptionSegmental.forEach(segment => transcriptionSegmentalSchema.push(''));
                this.$store.commit('setAnswerDataSchema', {
                    transcriptionSegmental: transcriptionSegmentalSchema
                });

                // Reset selected phonetic input index.
                this.$store.commit('setIdxSelectedPhoneticInput', 0);

                // Deactivate feedback phase.
                this.feedbackPhase = false;

                // Reset feedbackData.
                this.$store.commit('setFeedbackData', null);

                // Increment idxCurQUestion.
                this.$store.commit('setNextQuestion');

                // Play animations.
                try{
                    let elQuestionObject = document.querySelector('.question-object').classList.add('slide-in');
                    setTimeout(() => {document.querySelector('.question-object').classList.remove('slide-in');}, 500);
                }
                catch(err){

                }

                // Allow request.
                this.allow.request = true;
            },

            nextQuestionApi(){
                // Check if request is allowed.
                if(!this.allow.request){
                    console.warn("VIEW_PRACTICE_PHONETIC_TRANSCRIPTION/NEXT_QUESTION_API::REQUEST_NOT_ALLOWED");
                    return;
                }
                this.allow.request = false;

                // Show preloader.
                this.show.preloader = true;
                
                // Send request.
                fetch(this.$store.state.api.nextQuestion, {
                    method: 'POST',
                    credentials: 'include'
                })
                .then(async response => {
                    this.show.preloader = false;
                    this.allow.request  = true;
                    if(response.status != 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(nextQuestionData => {
                    // Update practice stats.
                    this.$store.commit('setPracticeStats', nextQuestionData.stats);

                    // Check if practice session is completed.
                    if(nextQuestionData.completion === true){
                        this.$router.push('/practice-results');
                        return;
                    }

                    // Set next question.
                    this.$store.commit('setIdxCurQuestion', nextQuestionData.idxCurQuestion);

                    // Reset dprops and vuex.
                    this.feedbackPhase = false;
                    this.scorelist = [-1, -1, -1];
                    this.correctness = null;
                    this.$store.commit('setFeedbackData', null);
                    this.$store.commit('setIdxSelectedPhoneticInput', 0);

                    // Update anwer data schema.
                    let answerDataSchema = {
                        transcriptionSegmental: Array(this.curQuestion.transcriptionSegmental.length).fill('')
                    };
                    this.$store.commit('setAnswerDataSchema', answerDataSchema);

                    // Play animations.
                    try{
                        let elQuestionObject = document.querySelector('.question-object').classList.add('slide-in');
                        setTimeout(() => {document.querySelector('.question-object').classList.remove('slide-in');}, 500);
                    }
                    catch(err){

                    }
                })
                .catch(err => {
                    console.error(err);
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                })
            },
        },

        created(){
            // Set selected phonetic transcription idx.
            this.$store.commit('setIdxSelectedPhoneticInput', 0);
            
            // Set answer data schema.
            let answerDataSchema = {
                transcriptionSegmental: Array(this.curQuestion.transcriptionSegmental.length).fill(''),
            };
            this.$store.commit('setAnswerDataSchema', answerDataSchema);
        }
    };
</script>
<style scoped src="@/css/views/view-practice-phonetic-transcription.css"></style>